import 'what-input';
import 'jquery-ujs';

import { notify } from 'src/global-helpers.js';

import 'src/components/SiteLogo/SiteLogo.sass';
import 'src/components/PersonCard/PersonCard.sass';
import 'src/components/InfoHint/InfoHint.sass';
import 'src/components/icons/SvgIcon/SvgIcon.sass';

import 'styles/globals.sass';
import 'styles/libs/normalize.css';
import 'styles/parts/forms.css.sass';
import 'styles/parts/buttons.css.sass';
import 'styles/parts/no_content.sass';
import 'styles/parts/social_buttons.css.sass';
import 'styles/views/layouts/auth.css.sass';

(() => {
  window.jQuery = jQuery;
  window.$ = jQuery;
  window.helpers = { notify };
  $('#user_agreement').on('change', function(){
    $('#submit_form').prop('disabled', !$(this).prop('checked') );
  });
})();
